const addSubcategory = (() => {
    //Inputs
    let BtnName;
    let SAVE_BTN = document.querySelector('.addOutcomeBtnWrap button');
    let categoryId, category, subCategory, code;
    var subCategoryInput; 
    let accountname, registerID, pageName;

    async function init(categoryID, Category, SubCategory, Code, accountName, registerId, page) {
        categoryId = categoryID;
        category = Category;
        subCategory = SubCategory;
        code = Code;
        accountname = accountName;
        registerID = registerId;
        pageName = page;

        buildNewSubCategory();
        if (SAVE_BTN) {
            SAVE_BTN.classList.add('disabled');
        }
    }

    async function buildNewSubCategory() {
        DOM.clearActionCenter();
        DOM.scrollToTopOfPage();
        landingPage = document.createElement('div')
        const importantOutcomeForm = await buildServicesForm();
        landingPage.appendChild(importantOutcomeForm);
        DOM.ACTIONCENTER.appendChild(landingPage);
    }

    async function buildServicesForm() {
        const employeeInfoDiv = document.createElement('div');
        employeeInfoDiv.classList.add('additionalQuestionWrap');

        if (subCategory != '') {
            BtnName = 'UPDATE';
        }
        else {
            subCategory = '';
            code = '';
            BtnName = 'SAVE';
        }

        categoryDropdown = dropdown.build({
            dropdownId: 'categoryDropdown',
            label: 'Category',
            style: 'secondary',
            value: category,
        });

        subCategoryInput = input.build({
            id: 'subCategoryInput',
            type: 'text',
            label: 'Subcategory',
            style: 'secondary',
            value: subCategory,
        });

        codeInput = input.build({
            id: 'codeInput',
            type: 'text',
            label: 'Code',
            style: 'secondary',
            value: code,
        });

        // button
        SAVE_BTN = button.build({
            text: BtnName,
            style: 'secondary',
            type: 'contained',
            callback: async () => {
                if (!SAVE_BTN.classList.contains('disabled')) {
                    SAVE_BTN.classList.add('disabled');
                    await saveUpdateSubcategory();
                }
            },
        });
        CANCEL_BTN = button.build({
            text: 'Cancel',
            style: 'secondary',
            type: 'outlined',
            callback: async () => { cfEditCategories.init(accountname, registerID, pageName) },
        });
        var LineBr = document.createElement('br');
        const column1 = document.createElement('div');
        column1.classList.add('col-1');
        const addNewCard = document.createElement("div");
        addNewCard.classList.add("card");
        const addNewCardBody = document.createElement("div");
        addNewCardBody.classList.add("card__body");
        addNewCard.innerHTML = `<div class="card__header">Category</div>`;
        addNewCard.appendChild(addNewCardBody);
        column1.appendChild(addNewCard);

        const addNewServiceCard = document.createElement("div");
        addNewServiceCard.classList.add("card");
        const addNewServiceCardBody = document.createElement("div");
        addNewServiceCardBody.classList.add("card__body");
        addNewServiceCard.innerHTML = `<div class="card__header">Subcategory</div>`;
        addNewServiceCard.appendChild(addNewServiceCardBody);  
        column1.appendChild(addNewServiceCard); 

        addNewCardBody.appendChild(categoryDropdown);

        addNewServiceCardBody.appendChild(subCategoryInput);
        var confirmMessage = document.createElement('div');
        confirmMessage.innerHTML = `<h3 id="confirmMessage" class="confirmMessage password-warning"></h3>`;
        confirmMessage.style.marginBottom = '15px';
        confirmMessage.style.marginTop = '-10px';
        confirmMessage.style.fontSize = '14px';
        addNewServiceCardBody.appendChild(confirmMessage);    

        addNewServiceCardBody.appendChild(codeInput);

        var btnWrap = document.createElement('div');
        btnWrap.classList.add('addOutcomeBtnWrap');
        btnWrap.style.marginLeft = '25%';
        btnWrap.style.width = '50%';

        SAVE_BTN.style.width = '52%';
        btnWrap.appendChild(SAVE_BTN);

        CANCEL_BTN.style.width = '52%';
        CANCEL_BTN.style.marginLeft = '5%';
        btnWrap.appendChild(CANCEL_BTN);
        addNewServiceCardBody.appendChild(btnWrap);

        employeeInfoDiv.appendChild(column1);
        populateSubCategoryDropdown();
        eventListeners();
        requiredFieldsOfAddCategory(category, subCategory);
        return employeeInfoDiv;
    }

    async function populateSubCategoryDropdown() {
        const { getCategoryDropDownOfFilterResult: categ } = await ConsumerFinancesAjax.getCategoryDropDownOfFilter();
        let categoryData = categ.map(categorys => ({
            id: categorys.CategoryID,
            value: categorys.CategoryDescription,
            text: categorys.CategoryDescription,
        }));
        categoryData.unshift({ id: '', value: '', text: '' });
        dropdown.populate('categoryDropdown', categoryData, category);
    }

    function eventListeners() {
        categoryDropdown.addEventListener("change", event => {
            var selectedOption = event.target.options[event.target.selectedIndex];
            category = selectedOption.value;
            checkrequiredFieldsOfAddCategory();
        });

        codeInput.addEventListener('input', event => {
            code = event.target.value.trim();
            checkrequiredFieldsOfAddCategory();
        });
        subCategoryInput.addEventListener('input', event => {
            subCategory = event.target.value.trim();
            checkrequiredFieldsOfAddCategory();
        });
    }

    function checkrequiredFieldsOfAddCategory() {
        var subcategoryVal = subCategoryInput.querySelector('#subCategoryInput');
        var categoryVal = categoryDropdown.querySelector('#categoryDropdown');

        requiredFieldsOfAddCategory(categoryVal.value, subcategoryVal.value)
    }

    function requiredFieldsOfAddCategory(categoryVal, subcategoryVal) {
        if (categoryVal.trim() === '') {
            categoryDropdown.classList.add('error');
        } else {
            categoryDropdown.classList.remove('error');
        }

        if (subcategoryVal.trim() === '') {
            subCategoryInput.classList.add('error');
        } else {
            subCategoryInput.classList.remove('error');
        }

        setBtnStatusOfAddCategory();
    }

    function setBtnStatusOfAddCategory() {
        var hasErrors = [].slice.call(document.querySelectorAll('.error'));
        if (hasErrors.length > 0) {
            SAVE_BTN.classList.add('disabled');
            return;
        } else {
            SAVE_BTN.classList.remove('disabled');
        }
    }

    async function saveUpdateSubcategory() {
        const result = await ConsumerFinancesAjax.insertUpdateSubCategory(categoryId, category.trim(), code.trim(), subCategory.trim());
        const { insertUpdateSubCategoryResult } = result;

        var messagetext = document.getElementById('confirmMessage');
        messagetext.innerHTML = ``;

        if (insertUpdateSubCategoryResult.CategoryID == '-1') {
            messagetext.innerHTML = 'This subcategory already exists.';
            subCategoryInput.classList.add('error');   
            messagetext.classList.add('password-error');
        } else { 
            cfEditCategories.init(accountname, registerID, pageName); 
        }
    }

    return {
        init,
        buildNewSubCategory,
    };
})();
